const emailShareImageSetup = () => {
	$('.mainImage').on('load', function () {
		var colorSwatchForShare = $(this).attr('src').split('?')[0],
			colorSplit = colorSwatchForShare.split('/');
		$('#shareImage').val(colorSplit[colorSplit.length - 1].split('.jpg').join(''));
	});
};

const inventoryOnHandEmail = (button) => {
	if ($('#inventoryOHOOForm').data('validForm')) {
		if ($('#OHOOEmail').val()) {
			$.ajax({
				url: '/webapp/wcs/stores/servlet/InventoryOHOO',
				cache: false,
				type: 'POST',
				data: $('#inventoryOHOOForm').serialize(),
			});
			$('.modal-footer').show();
			$('#OHOOEmailInput').html('Thank you! You will receive an email as soon as this item becomes available.').addClass('alert-success');
			$('.modal-left .checkoutContainer').show();
		}

		//   $(".modal-header > .close").click();
		//   if (button != undefined && $(button).data("href").length > 0) {
		//       spinStart();
		//       window.location = $(button).data("href");
		//   }
		return false;
	}
};

export { emailShareImageSetup, inventoryOnHandEmail };
